import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _05d88f66 = () => interopDefault(import('..\\pages\\bedrijven\\index.vue' /* webpackChunkName: "pages/bedrijven/index" */))
const _37b08772 = () => interopDefault(import('..\\pages\\construction.vue' /* webpackChunkName: "pages/construction" */))
const _843d1816 = () => interopDefault(import('..\\pages\\instellingen\\index.vue' /* webpackChunkName: "pages/instellingen/index" */))
const _7813bf2c = () => interopDefault(import('..\\pages\\login\\index.vue' /* webpackChunkName: "pages/login/index" */))
const _f23be10a = () => interopDefault(import('..\\pages\\opdrachten\\index.vue' /* webpackChunkName: "pages/opdrachten/index" */))
const _0d0420a7 = () => interopDefault(import('..\\pages\\overzicht\\index.vue' /* webpackChunkName: "pages/overzicht/index" */))
const _fefaddf0 = () => interopDefault(import('..\\pages\\personeelsplanning\\index.vue' /* webpackChunkName: "pages/personeelsplanning/index" */))
const _608e6416 = () => interopDefault(import('..\\pages\\relaties\\index.vue' /* webpackChunkName: "pages/relaties/index" */))
const _6949948e = () => interopDefault(import('..\\pages\\urenregistratie\\index.vue' /* webpackChunkName: "pages/urenregistratie/index" */))
const _7b37834a = () => interopDefault(import('..\\pages\\werknemers\\index.vue' /* webpackChunkName: "pages/werknemers/index" */))
const _72149ae6 = () => interopDefault(import('..\\pages\\account\\registreren.vue' /* webpackChunkName: "pages/account/registreren" */))
const _f3fbb618 = () => interopDefault(import('..\\pages\\bedrijven\\aanmaken\\index.vue' /* webpackChunkName: "pages/bedrijven/aanmaken/index" */))
const _1665b9fb = () => interopDefault(import('..\\pages\\bedrijven\\bekijken\\index.vue' /* webpackChunkName: "pages/bedrijven/bekijken/index" */))
const _7146a7a7 = () => interopDefault(import('..\\pages\\bedrijven\\subscriptie\\index.vue' /* webpackChunkName: "pages/bedrijven/subscriptie/index" */))
const _1580cfd4 = () => interopDefault(import('..\\pages\\instellingen\\labels\\index.vue' /* webpackChunkName: "pages/instellingen/labels/index" */))
const _bae796a4 = () => interopDefault(import('..\\pages\\instellingen\\ort\\index.vue' /* webpackChunkName: "pages/instellingen/ort/index" */))
const _ac81e810 = () => interopDefault(import('..\\pages\\instellingen\\subscription\\index.vue' /* webpackChunkName: "pages/instellingen/subscription/index" */))
const _bf2a35ca = () => interopDefault(import('..\\pages\\login\\index copy.vue' /* webpackChunkName: "pages/login/index copy" */))
const _923095ac = () => interopDefault(import('..\\pages\\login\\profielen\\index.vue' /* webpackChunkName: "pages/login/profielen/index" */))
const _57bd166e = () => interopDefault(import('..\\pages\\login\\uitnodiging\\index.vue' /* webpackChunkName: "pages/login/uitnodiging/index" */))
const _b1a5b2fe = () => interopDefault(import('..\\pages\\login\\verifieer\\index.vue' /* webpackChunkName: "pages/login/verifieer/index" */))
const _c5388034 = () => interopDefault(import('..\\pages\\login\\wachtwoord\\index.vue' /* webpackChunkName: "pages/login/wachtwoord/index" */))
const _c023626e = () => interopDefault(import('..\\pages\\opdrachten\\aanmaken\\index.vue' /* webpackChunkName: "pages/opdrachten/aanmaken/index" */))
const _3051e3d0 = () => interopDefault(import('..\\pages\\opdrachten\\bekijken\\index.vue' /* webpackChunkName: "pages/opdrachten/bekijken/index" */))
const _1352e0a2 = () => interopDefault(import('..\\pages\\personeelsplanning\\index-with-store.vue' /* webpackChunkName: "pages/personeelsplanning/index-with-store" */))
const _75132988 = () => interopDefault(import('..\\pages\\profielen\\bekijken\\index.vue' /* webpackChunkName: "pages/profielen/bekijken/index" */))
const _320f6fad = () => interopDefault(import('..\\pages\\profielen\\overzicht.vue' /* webpackChunkName: "pages/profielen/overzicht" */))
const _f88c44b8 = () => interopDefault(import('..\\pages\\relaties\\aanmaken\\index.vue' /* webpackChunkName: "pages/relaties/aanmaken/index" */))
const _141d72ab = () => interopDefault(import('..\\pages\\relaties\\bekijken\\index.vue' /* webpackChunkName: "pages/relaties/bekijken/index" */))
const _7ab39c2e = () => interopDefault(import('..\\pages\\relaties\\index-new.vue' /* webpackChunkName: "pages/relaties/index-new" */))
const _d2caec60 = () => interopDefault(import('..\\pages\\uren\\bekijken\\index.vue' /* webpackChunkName: "pages/uren/bekijken/index" */))
const _0f3c8bd8 = () => interopDefault(import('..\\pages\\werknemers\\aanmaken\\index.vue' /* webpackChunkName: "pages/werknemers/aanmaken/index" */))
const _c0bfbe42 = () => interopDefault(import('..\\pages\\werknemers\\bekijken\\index.vue' /* webpackChunkName: "pages/werknemers/bekijken/index" */))
const _342a4e96 = () => interopDefault(import('..\\pages\\instellingen\\ort\\regels\\index.vue' /* webpackChunkName: "pages/instellingen/ort/regels/index" */))
const _07077e56 = () => interopDefault(import('..\\pages\\instellingen\\planner\\volgorde\\index.vue' /* webpackChunkName: "pages/instellingen/planner/volgorde/index" */))
const _108175a9 = () => interopDefault(import('..\\pages\\instellingen\\rapport\\export\\index.vue' /* webpackChunkName: "pages/instellingen/rapport/export/index" */))
const _8a6b1280 = () => interopDefault(import('..\\pages\\instellingen\\rollen\\rechten\\index.vue' /* webpackChunkName: "pages/instellingen/rollen/rechten/index" */))
const _408a1716 = () => interopDefault(import('..\\pages\\login\\wachtwoord\\aanvragen\\index.vue' /* webpackChunkName: "pages/login/wachtwoord/aanvragen/index" */))
const _3a9de3a0 = () => interopDefault(import('..\\pages\\relaties\\bekijken\\contacten\\index.vue' /* webpackChunkName: "pages/relaties/bekijken/contacten/index" */))
const _5828b027 = () => interopDefault(import('..\\pages\\relaties\\bekijken\\documenten\\index.vue' /* webpackChunkName: "pages/relaties/bekijken/documenten/index" */))
const _89448a0a = () => interopDefault(import('..\\pages\\relaties\\bekijken\\gegevens\\index.vue' /* webpackChunkName: "pages/relaties/bekijken/gegevens/index" */))
const _31b3b05b = () => interopDefault(import('..\\pages\\werknemers\\bekijken\\documenten\\index.vue' /* webpackChunkName: "pages/werknemers/bekijken/documenten/index" */))
const _07598fa2 = () => interopDefault(import('..\\pages\\werknemers\\bekijken\\gegevens\\index.vue' /* webpackChunkName: "pages/werknemers/bekijken/gegevens/index" */))
const _758a6232 = () => interopDefault(import('..\\pages\\werknemers\\bekijken\\index-new.vue' /* webpackChunkName: "pages/werknemers/bekijken/index-new" */))
const _431ca601 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/bedrijven",
    component: _05d88f66,
    pathToRegexpOptions: {"strict":true},
    name: "bedrijven"
  }, {
    path: "/construction",
    component: _37b08772,
    pathToRegexpOptions: {"strict":true},
    name: "construction"
  }, {
    path: "/instellingen",
    component: _843d1816,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen"
  }, {
    path: "/login",
    component: _7813bf2c,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/opdrachten",
    component: _f23be10a,
    pathToRegexpOptions: {"strict":true},
    name: "opdrachten"
  }, {
    path: "/overzicht",
    component: _0d0420a7,
    pathToRegexpOptions: {"strict":true},
    name: "overzicht"
  }, {
    path: "/personeelsplanning",
    component: _fefaddf0,
    pathToRegexpOptions: {"strict":true},
    name: "personeelsplanning"
  }, {
    path: "/relaties",
    component: _608e6416,
    pathToRegexpOptions: {"strict":true},
    name: "relaties"
  }, {
    path: "/urenregistratie",
    component: _6949948e,
    pathToRegexpOptions: {"strict":true},
    name: "urenregistratie"
  }, {
    path: "/werknemers",
    component: _7b37834a,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers"
  }, {
    path: "/account/registreren",
    component: _72149ae6,
    pathToRegexpOptions: {"strict":true},
    name: "account-registreren"
  }, {
    path: "/bedrijven/aanmaken",
    component: _f3fbb618,
    pathToRegexpOptions: {"strict":true},
    name: "bedrijven-aanmaken"
  }, {
    path: "/bedrijven/bekijken",
    component: _1665b9fb,
    pathToRegexpOptions: {"strict":true},
    name: "bedrijven-bekijken"
  }, {
    path: "/bedrijven/subscriptie",
    component: _7146a7a7,
    pathToRegexpOptions: {"strict":true},
    name: "bedrijven-subscriptie"
  }, {
    path: "/instellingen/labels",
    component: _1580cfd4,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-labels"
  }, {
    path: "/instellingen/ort",
    component: _bae796a4,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-ort"
  }, {
    path: "/instellingen/subscription",
    component: _ac81e810,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-subscription"
  }, {
    path: "/login/index%20copy",
    component: _bf2a35ca,
    pathToRegexpOptions: {"strict":true},
    name: "login-index copy"
  }, {
    path: "/login/profielen",
    component: _923095ac,
    pathToRegexpOptions: {"strict":true},
    name: "login-profielen"
  }, {
    path: "/login/uitnodiging",
    component: _57bd166e,
    pathToRegexpOptions: {"strict":true},
    name: "login-uitnodiging"
  }, {
    path: "/login/verifieer",
    component: _b1a5b2fe,
    pathToRegexpOptions: {"strict":true},
    name: "login-verifieer"
  }, {
    path: "/login/wachtwoord",
    component: _c5388034,
    pathToRegexpOptions: {"strict":true},
    name: "login-wachtwoord"
  }, {
    path: "/opdrachten/aanmaken",
    component: _c023626e,
    pathToRegexpOptions: {"strict":true},
    name: "opdrachten-aanmaken"
  }, {
    path: "/opdrachten/bekijken",
    component: _3051e3d0,
    pathToRegexpOptions: {"strict":true},
    name: "opdrachten-bekijken"
  }, {
    path: "/personeelsplanning/index-with-store",
    component: _1352e0a2,
    pathToRegexpOptions: {"strict":true},
    name: "personeelsplanning-index-with-store"
  }, {
    path: "/profielen/bekijken",
    component: _75132988,
    pathToRegexpOptions: {"strict":true},
    name: "profielen-bekijken"
  }, {
    path: "/profielen/overzicht",
    component: _320f6fad,
    pathToRegexpOptions: {"strict":true},
    name: "profielen-overzicht"
  }, {
    path: "/relaties/aanmaken",
    component: _f88c44b8,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-aanmaken"
  }, {
    path: "/relaties/bekijken",
    component: _141d72ab,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-bekijken"
  }, {
    path: "/relaties/index-new",
    component: _7ab39c2e,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-index-new"
  }, {
    path: "/uren/bekijken",
    component: _d2caec60,
    pathToRegexpOptions: {"strict":true},
    name: "uren-bekijken"
  }, {
    path: "/werknemers/aanmaken",
    component: _0f3c8bd8,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-aanmaken"
  }, {
    path: "/werknemers/bekijken",
    component: _c0bfbe42,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-bekijken"
  }, {
    path: "/instellingen/ort/regels",
    component: _342a4e96,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-ort-regels"
  }, {
    path: "/instellingen/planner/volgorde",
    component: _07077e56,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-planner-volgorde"
  }, {
    path: "/instellingen/rapport/export",
    component: _108175a9,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-rapport-export"
  }, {
    path: "/instellingen/rollen/rechten",
    component: _8a6b1280,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen-rollen-rechten"
  }, {
    path: "/login/wachtwoord/aanvragen",
    component: _408a1716,
    pathToRegexpOptions: {"strict":true},
    name: "login-wachtwoord-aanvragen"
  }, {
    path: "/relaties/bekijken/contacten",
    component: _3a9de3a0,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-bekijken-contacten"
  }, {
    path: "/relaties/bekijken/documenten",
    component: _5828b027,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-bekijken-documenten"
  }, {
    path: "/relaties/bekijken/gegevens",
    component: _89448a0a,
    pathToRegexpOptions: {"strict":true},
    name: "relaties-bekijken-gegevens"
  }, {
    path: "/werknemers/bekijken/documenten",
    component: _31b3b05b,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-bekijken-documenten"
  }, {
    path: "/werknemers/bekijken/gegevens",
    component: _07598fa2,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-bekijken-gegevens"
  }, {
    path: "/werknemers/bekijken/index-new",
    component: _758a6232,
    pathToRegexpOptions: {"strict":true},
    name: "werknemers-bekijken-index-new"
  }, {
    path: "/",
    component: _431ca601,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
